module.exports = __webpack_public_path__ + "img/student-plan.68d3a299.svg";